export const getInitialState = (): any => ({
  dataProcessingData: {},
  dataProcessingStatus: 0
});
